import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import authRoutes from "./routes/authRoutes";
import dashboardRoutes from "./routes/dashboardRoutes";
import orderRoutes from "./routes/orderRoutes";
import {ThemeProvider} from "./provider/ThemeProvider";

// Combine all route configurations
const allRoutes = [...authRoutes, ...dashboardRoutes, ...orderRoutes];

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <ToastContainer />
        <Routes>
          {allRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
